import { withTranslation } from "react-i18next";

import React from 'react';
import { Link } from 'react-router-dom';
import { Footer } from '../Common/Footer';
import { SideBar } from '../Common/SideBar';
import { DashboardHeader } from '../Common/DashboardHeader';
import Profile from '../../Models/Profile';
import { Header } from '../Common';
import Common from "../../Models/Common";
class PortfolioAll extends React.Component {
    constructor(props) {
        super(props);
        let x = JSON.parse(localStorage.getItem('info'))
        if (x === null || x === '') {
            alert(this.props.t('0'))
            this.props.history.push('/login/seller');
        };
        var retrievedObject = window.localStorage.getItem('info');
        var logged_user = JSON.parse(retrievedObject);
        // console.log(logged_user)
        this.state = {
            _id: false,
            portfolio: [],
            user: logged_user
        };
    }
    componentDidMount() {

        window.scrollTo(0, 0)
        Profile.getPortfolioAll(this.state.user.id).then(res => {
            if (res.data.payload != null) {
                this.setState({ portfolio: res.data.payload })
            }
        })
    }
    render() {
        const isMobile = window.innerWidth <= 500;
        const isDesktop = window.innerWidth >= 500;
        if (isMobile) {
            return (
                <div className="wrapper">
                    <Header />
                    <div className="col-md-12 tr_blank_medium mt-5 pt-4"></div>
                    <div className="col-md-12 tr_blank_medium mt-5 "></div>
                    <div className="container-fluid main">
                        <div className="row">
                            {/* <div className="col-md-4 input_name">
                                <SideBar />
                            </div> */}
                            <div className="col-md-8">
                                <div className="mt-5 mb-3 input_name big_font guide_text" style={{ width: '100%' }}>
                                    {this.props.t('1')}
                                    </div>
                                {(() => {
                                    if (this.state.portfolio.length === 0) {
                                        return (
                                            <div></div>
                                        )
                                    } else {
                                        return (
                                            <div style={{ border: "1px solid #bababa", minHeight: "550px", padding: "2%", textAlign: "center" }}>
                                                {this.state.portfolio.map(group =>
                                                    <div className="service-list-divs">
                                                        <div className=" row">
                                                            <div className="col-md-3">
                                                                <img alt="" src={Common.baseUrl + group.img} style={{ width: "100%" }}></img>
                                                            </div>
                                                            <div className="col-md-9">
                                                                <div className=" row">
                                                                    <div className="col-md-3" style={{ textAlign: "left" }}>
                                                                        <b><i>{this.props.t('5')}</i></b>
                                                                    </div>
                                                                    <div className="col-md-8" style={{ textAlign: "left" }}>
                                                                        <Link to={{
                                                                            pathname: `/portfolio-details/${group.id}`
                                                                        }}>
                                                                            {group.title}
                                                                        </Link>
                                                                    </div>
                                                                </div>
                                                                <div className=" row">
                                                                    <div className="col-md-3" style={{ textAlign: "left" }}>
                                                                        <b><i>{this.props.t('7')}</i></b>
                                                                    </div>
                                                                    <div className="col-md-8" style={{ textAlign: "left" }}>
                                                                        {group.details.substr(0, 100)}
                                                                    </div>
                                                                </div>
                                                                <div className=" row" style={{display: "none"}}>
                                                                    <div className="col-md-3" style={{ textAlign: "left" }}>
                                                                        <b><i>{this.props.t('3')}</i></b>
                                                                    </div>
                                                                    <div className="col-md-8" style={{ textAlign: "left" }}>
                                                                        {group.cat_name}
                                                                    </div>
                                                                </div>
                                                                <div className=" row">
                                                                    <div className="col-md-3" style={{ textAlign: "left" }}>
                                                                        <b><i>{this.props.t('8')}</i></b>
                                                                    </div>
                                                                    <div className="col-md-8" style={{ textAlign: "left" }}>
                                                                        {group.updated_at}
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                )}
                                            </div>
                                        )
                                    }
                                })()}

                            </div>
                        </div>
                    </div>
                    <Footer />
                </div>
            )
        } else if (isDesktop) {
            return (
                <div className="wrapper">
                    <Header />
                    <div className="col-md-12 tr_blank_medium mt-5 pt-4"></div>
                    <div className="col-md-12 tr_blank_medium mt-5 "></div>
                    <div className="container-fluid main">
                        <div className="container">
                            <div className="col-md-12">
                                <div className="row">
                                    <div className="col-md-4 input_name">
                                        <SideBar />
                                    </div>
                                    <div className="col-md-8">
                                        <div className="mt-5 mb-3 input_name big_font guide_text" style={{ width: '100%' }}>
                                            {this.props.t('1')}
                                    </div>
                                        {(() => {
                                            if (this.state.portfolio.length === 0) {
                                                return (
                                                    <div></div>
                                                )
                                            } else {
                                                return (
                                                    <div style={{ border: "1px solid #bababa", minHeight: "550px", padding: "2%", textAlign: "center" }}>
                                                        {this.state.portfolio.map(group =>
                                                            <div className="service-list-divs">
                                                                <div className=" row">
                                                                    <div className="col-md-3">
                                                                        <img alt="" src={Common.baseUrl + group.img} style={{ width: "100%" }}></img>
                                                                    </div>
                                                                    <div className="col-md-9">
                                                                        <div className=" row">
                                                                            <div className="col-md-3" style={{ textAlign: "right" }}>
                                                                                <b><i>{this.props.t('5')}:</i></b>
                                                                            </div>
                                                                            <div className="col-md-8" style={{ textAlign: "left" }}>
                                                                                <Link to={{
                                                                                    pathname: `/portfolio-details/${group.id}`
                                                                                }}>
                                                                                    {group.title}
                                                                                </Link>
                                                                            </div>
                                                                        </div>
                                                                        <div className=" row">
                                                                            <div className="col-md-3" style={{ textAlign: "right" }}>
                                                                                <b><i>{this.props.t('7')}:</i></b>
                                                                            </div>
                                                                            <div className="col-md-8" style={{ textAlign: "left" }}>
                                                                                {group.details.substr(0, 100)}
                                                                                {/* {group.details.split('\n').map(function (item, key) {
                                                                                return (
                                                                                    <span key={key}>
                                                                                        {item}
                                                                                        <br />
                                                                                    </span>
                                                                                )
                                                                            })} */}
                                                                            </div>
                                                                        </div>
                                                                        <div className=" row" style={{display: "none"}}>
                                                                            <div className="col-md-3" style={{ textAlign: "right" }}>
                                                                                <b><i>{this.props.t('3')}:</i></b>
                                                                            </div>
                                                                            <div className="col-md-8" style={{ textAlign: "left" }}>
                                                                                {group.cat_name}
                                                                            </div>
                                                                        </div>
                                                                        <div className=" row">
                                                                            <div className="col-md-3" style={{ textAlign: "right" }}>
                                                                                <b><i>{this.props.t('8')}:</i></b>
                                                                            </div>
                                                                            <div className="col-md-8" style={{ textAlign: "left" }}>
                                                                                {group.updated_at}
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        )}
                                                    </div>
                                                )
                                            }
                                        })()}

                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <Footer />
                </div>
            )
        }
    }
}
export { PortfolioAll }


 PortfolioAll = withTranslation('src_Components_Profile_PortfolioAll')(PortfolioAll);
